import { RedeemableTicket, RedeemableTicketSearch } from '@givebacks/api/store';
import { createTable } from 'core/Packages';

type EventCheckInTableInstanceMeta = {
  causeId?: string;
};

const EventCheckInTableInstance = createTable<
  RedeemableTicket,
  RedeemableTicketSearch,
  EventCheckInTableInstanceMeta
>();

export { EventCheckInTableInstance };
